import { combineReducers } from 'redux';
import home from './home';
import about from './about';
import catalogReducer from './catalog'
import depositReducer from './depositReducer'

const reduxState = combineReducers({
  catalogReducer,
  depositReducer,
  home,
  about
});

export default reduxState;
